import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="16" height="10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M14.496 5s-2.903 3.6-6.492 3.6C4.416 8.6 1.512 5 1.512 5s2.904-3.6 6.492-3.6c3.589 0 6.492 3.6 6.492 3.6z" stroke="#A7A7A7" strokeMiterlimit="10" /><path d="M8.005 7c1.086 0 1.967-.895 1.967-2s-.88-2-1.967-2c-1.087 0-1.968.895-1.968 2s.88 2 1.968 2z" stroke="#A7A7A7" strokeMiterlimit="10" /></svg>);